module.exports = __webpack_public_path__ + "assets/calendar_white.bf9b0c72.svg";